import React, { Component, Fragment } from 'react';
import moment from 'moment/moment';
import 'moment/locale/fr';

moment.locale('fr');

const OneEvent = ({ date, day, artist, subtitle, description, dir }) => (
  <div className={`event text-${dir} txt-white m-3`}>
    <span className="txt-bold txt-25px txt-uppercase">{date}</span>
    <span className="txt-thin m-3"> {day} </span>
    <span className="txt-bold txt-25px txt-uppercase">{artist}</span>
    {description && (
      <span
        className="fa fa-info-circle"
        style={{ marginLeft: 8, fontSize: 20, color: 'rgba(255, 255, 255, .8)' }}
        onClick={() => alert(description)}
      />
    )}
    {subtitle && (
      <Fragment>
        <br />
        <span className="txt-thin" style={{ marginLeft: 90 }}>
          {subtitle}
        </span>
      </Fragment>
    )}
  </div>
);

class PerformingTreesome extends Component {
  render() {
    return (
      <div className="treesome-performing-bg" id="events">
        <div className="row m-0">
          <div className="col-md-6 col-sm-12 text-right bg-darkned event-box">
            <div className="txt-uppercase txt-white">
              <h1 className="txt-bold txt-25px event-box-title">per-</h1>
              <h1 className="txt-bold txt-25px event-box-title">forming</h1>
            </div>
            <hr className="txt-separator float-right" />
            <span className="txt-uppercase txt-thin txt-spaced-2">this week</span>
          </div>
          <div className="col-md-6 col-sm-12 align-items-start event-box">
            {this.props.data.length > 0 ? (
              this.props.data.map(item => {
                return (
                  <OneEvent
                    date={moment(item.date).date()}
                    day={moment(item.date)
                      .format('ddd')
                      .toUpperCase()}
                    artist={item.name}
                    subtitle={item.subTitle}
                    description={item.description}
                    dir="left"
                  />
                );
              })
            ) : (
              <div className="txt-thin p-5 m-5">Pas des performing programmés pour cette semaine.</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default PerformingTreesome;



// WEBPACK FOOTER //
// ./src/components/treesome/PerformingTreesome.js